import Link from 'next/link';
import styles from './homepageSummitBanner.module.scss';

const HomepageSummitBanner = () => (
  <aside className={styles.banner} aria-label="Baseline Summit announcement">
    <p className={styles.copy}>
      Connect, learn, and shape what&apos;s next at Baseline Summit &apos;27.{' '}
      <Link className={styles.link} href="/events/baseline-summit">
        Reserve your spot
      </Link>
    </p>
  </aside>
);

export default HomepageSummitBanner;
